import React from 'react';
import { Link } from 'react-router-dom';
import { Stethoscope, Award, Clock, Users, CheckCircle, Star } from 'lucide-react';
import vasha from '../images/vasha.png';
const Home = () => {
  return (
    <div data-testid="home-page">
      {/* Hero Section */}
      <section className="hero" data-testid="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="specialty-badge" data-testid="specialty-badge">
                <Stethoscope className="inline mr-2" size={16} />
                General & Upper GI Surgeon
              </div>
              <h1 className="heading-primary" data-testid="hero-title">
                Consultant Surgeon Prof. Vasha Kaur
              </h1>
              <p className="text-large" data-testid="hero-subtitle">
                Specialist in metabolic health, weight loss, gallbladder and hernia surgery
              </p>
              <p className="text-base mb-8" data-testid="hero-description">
                Providing expert surgical care with a focus on patient-centred treatment and 
                innovative medical solutions in London and Surrey.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/contact" 
                  className="btn btn-primary btn-large"
                  data-testid="book-appointment-btn"
                >
                  Book Appointment
                </Link>
                <Link 
                  to="/services" 
                  className="btn btn-secondary btn-large"
                  data-testid="view-services-btn"
                >
                  View Services
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <img 
src={vasha}
alt="Consultant Surgeon Vasha Kaur"
                data-testid="hero-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="section bg-gradient-modern" data-testid="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card floating-element" data-testid="stat-experience">
              <div className="stat-number">15+</div>
              <div className="stat-label">Years’ Experience</div>
            </div>
            <div className="stat-card floating-element" data-testid="stat-procedures">
              <div className="stat-number">2000+</div>
              <div className="stat-label">Successful Procedures</div>
            </div>
            <div className="stat-card floating-element" data-testid="stat-patients">
              <div className="stat-number">98%</div>
              <div className="stat-label">Patient Satisfaction</div>
            </div>
            <div className="stat-card floating-element" data-testid="stat-awards">
              <div className="stat-number">50+</div>
              <div className="stat-label">Medical Publications</div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview with Images */}
           {/* Services Preview with Images */}
      <section className="section" data-testid="services-preview">
        <div className="container">
          <div className="text-center mb-16">
            <h2 className="heading-secondary" data-testid="services-title">Our Specialised Services</h2>
            <p className="text-large" data-testid="services-subtitle">
              Comprehensive surgical care using the latest minimally invasive techniques
            </p>
          </div>
          
          <div className="grid grid-3 gap-8">
            {/* 1. Metabolic Health & Weight Loss */}
            <div className="service-card" data-testid="service-metabolic">
              <div 
                className="service-image" 
                style={{
                  backgroundImage: `url('https://images.unsplash.com/photo-1744829903372-6e6f254780bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwc3VyZ2VyeXxlbnwwfHx8fDE3NTk1MjU1ODZ8MA&ixlib=rb-4.1.0&q=85')`
                }}
              />
              <div className="service-content">
                <div className="service-icon">
                  <Users className="text-blue-600" size={28} />
                </div>
                <h3 className="heading-tertiary mb-3">Metabolic Health & Weight Loss</h3>
                <p className="card-content mb-4">
                  Advanced approaches to metabolic disorders and sustainable weight management solutions.
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-center gap-2">
                    <CheckCircle size={16} className="text-green-500" />
                    Comprehensive lifestyle programmes
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle size={16} className="text-green-500" />
                    Pharmacological management
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle size={16} className="text-green-500" />
                    Surgical options
                  </li>
                </ul>
              </div>
            </div>
            
            {/* 2. Gallbladder Surgery */}
            <div className="service-card" data-testid="service-gallbladder">
              <div 
                className="service-image" 
                style={{
                  backgroundImage: `url('https://images.unsplash.com/photo-1606431424031-dbdedefc5bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxtZWRpY2FsJTIwc3VyZ2VyeXxlbnwwfHx8fDE3NTk1MjU1ODZ8MA&ixlib=rb-4.1.0&q=85')`
                }}
              />
              <div className="service-content">
                <div className="service-icon">
                  <Stethoscope className="text-blue-600" size={28} />
                </div>
                <h3 className="heading-tertiary mb-3">Gallbladder Surgery</h3>
                <p className="card-content mb-4">
                  Expert laparoscopic treatment of gallbladder conditions with minimal scarring and faster recovery times.
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-center gap-2">
                    <CheckCircle size={16} className="text-green-500" />
                    Laparoscopic cholecystectomy
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle size={16} className="text-green-500" />
                    Gallstone treatment
                  </li>
                </ul>
              </div>
            </div>
            
            {/* 3. Hernia Surgery */}
            <div className="service-card" data-testid="service-hernia">
              <div 
                className="service-image" 
                style={{
                  backgroundImage: `url('https://images.unsplash.com/photo-1606685622133-ed6fbaaf445c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxtZWRpY2FsJTIwc3VyZ2VyeXxlbnwwfHx8fDE3NTk1MjU1ODZ8MA&ixlib=rb-4.1.0&q=85')`
                }}
              />
              <div className="service-content">
                <div className="service-icon">
                  <Award className="text-blue-600" size={28} />
                </div>
                <h3 className="heading-tertiary mb-3">Hernia Surgery</h3>
                <p className="card-content mb-4">
                  Comprehensive hernia repair using both traditional and innovative techniques tailored to individual needs.
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-center gap-2">
                    <CheckCircle size={16} className="text-green-500" />
                    Inguinal hernia repair
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle size={16} className="text-green-500" />
                    Umbilical hernia surgery
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle size={16} className="text-green-500" />
                    Abdominal wall hernia
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* View More CTA (Home shows 3, full list on /services) */}
          <div className="mt-12 text-center">
            <Link
              to="/services"
              className="btn btn-secondary btn-large"
              data-testid="view-more-services-btn"
              aria-label="View more services"
            >
              View more services
            </Link>
          </div>
        </div>
      </section>


      {/* Why Choose Us Section */}
      <section className="section bg-medical-light parallax-section" data-testid="why-choose-section">
        <div className="container">
          <div className="text-center mb-16">
            <h2 className="heading-secondary" data-testid="why-choose-title">
              Why Choose Vasha Kaur?
            </h2>
            <p className="text-large" data-testid="why-choose-subtitle">
              Excellence in surgical care with a patient-first approach
            </p>
          </div>
          
          <div className="grid grid-3 gap-8">
            <div className="card text-center" data-testid="excellence-card">
              <div className="card-header">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Award className="text-blue-600" size={40} />
                </div>
                <h3 className="heading-tertiary">Proven Excellence</h3>
              </div>
              <div className="card-content">
                <p>Outstanding surgical outcomes with international recognition in medical education and research.</p>
              </div>
            </div>
            
            <div className="card text-center" data-testid="innovation-card">
              <div className="card-header">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Stethoscope className="text-blue-600" size={40} />
                </div>
                <h3 className="heading-tertiary">Advanced Technology</h3>
              </div>
              <div className="card-content">
                <p>Utilising cutting-edge minimally invasive surgical techniques and the latest medical technology for superior patient outcomes.</p>
              </div>
            </div>
            
            <div className="card text-center" data-testid="care-card">
              <div className="card-header">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Users className="text-blue-600" size={40} />
                </div>
                <h3 className="heading-tertiary">Personalised Care</h3>
              </div>
              <div className="card-content">
                <p>Individual treatment plans designed specifically for each patient’s unique needs, ensuring the best possible surgical and recovery experience.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Patient Testimonials */}
      <section className="section" data-testid="testimonials-section">
        <div className="container">
          <div className="text-center mb-16">
            <h2 className="heading-secondary" data-testid="testimonials-title">
              What Our Patients Say
            </h2>
            <p className="text-large" data-testid="testimonials-subtitle">
              Real experiences from patients who received exceptional care
            </p>
          </div>
          
          <div className="grid grid-2 gap-8 max-w-5xl mx-auto">
            <div className="card" data-testid="testimonial-1">
              <div className="mb-6">
                <div className="flex gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star key={star} className="text-yellow-400 fill-current" size={24} />
                  ))}
                </div>
                <p className="text-lg text-gray-700 italic leading-relaxed mb-6">
                  "Vasha Kaur performed my gallbladder surgery with exceptional skill. The minimally 
                  invasive approach meant I was back to normal activities much sooner than expected. 
                  Her clear explanations and compassionate care made the entire process comfortable."
                </p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                    <Users className="text-blue-600" size={20} />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-lg">Sarah M.</p>
                    <p className="text-gray-500">Gallbladder Surgery Patient</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section bg-gradient-modern" data-testid="cta-section">
        <div className="container text-center">
          <div className="max-w-4xl mx-auto">
            <h2 className="heading-secondary mb-6" data-testid="cta-title">
              Ready to Take the Next Step?
            </h2>
            <p className="text-large mb-8" data-testid="cta-description">
              Schedule your consultation with Vasha Kaur and discover how 
              expert surgical care can improve your quality of life.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/contact" 
                className="btn btn-primary btn-large"
                data-testid="cta-book-btn"
              >
                <Clock className="mr-2" size={20} />
                Schedule Consultation
              </Link>
              <Link 
                to="/patient-info" 
                className="btn btn-secondary btn-large"
                data-testid="cta-info-btn"
              >
                Patient Information
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
